import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/esm/objectWithoutProperties";
var _excluded = ["theme", "size", "className"];
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import "./index.css";
import styles from "./index.css.js";
var sizeStyles = {
  "s": styles.sizeS,
  "m": styles.sizeM,
  "l": styles.sizeL
};
export var Size = {
  "s": "s",
  "m": "m",
  "l": "l"
};
var HamburgerIcon = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var theme = _ref.theme,
      size = _ref.size,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props, {
    className: cn(styles.icon, styles[theme], sizeStyles[size], className),
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.004 5h-16v2h16V5zm0 6h-16v2h16v-2zm-16 6h16v2h-16v-2z"
  }));
});
HamburgerIcon.propTypes = {
  className: PropTypes.string,
  theme: PropTypes.oneOf(["light", "dark"]),
  size: PropTypes.oneOf(["s", "m", "l"])
};
HamburgerIcon.defaultProps = {
  size: "m"
};
export default HamburgerIcon;
//# sourceMappingURL=hamburger.js.map